var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dynamic_variables)?_c('div',[_c('h5',[_vm._v("Dynamic Variables:")]),_c('div',{staticClass:"d-flex mb-4"},_vm._l((_vm.dynamic_variables),function(item,index){return _c('div',{key:index,staticClass:"py-2 mr-5"},[_c('CopyItem',{attrs:{"item":item,"insert":_vm.insertText}})],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }